import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ApiPackage, ApiQuoteResponse } from '@bhtp-client-api/base';
import { FieldConfigs } from '@bhtp-client-web/component';
import { ConstraintRules } from '@bhtp-client-api/eligibility';
import { PackageAgreement } from '@bhtp-client-api/purchase';
import { Observable } from 'rxjs';

import { PurchaseNavigationService } from './purchase-navigation.service';
import { PurchaseData } from './../shared';
import { WriteValueOverride } from './models';

@Component({
    selector: 'navigation-step',
    template: ''
})
export abstract class NavigationStepComponent {
    @Output() public quotingStatusChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    // set by navigation service to let component know that the form
    // was submitted via advancing in purchase path
    public submitted: boolean = false;

    // Set by navigation service to let component know that
    // navigation to next was attempted
    public tryingToContinue: boolean = false;

    // latest values in the purchase path. Use to fill in form fields,
    // in validation rules, etc.
    public currentPurchaseData: PurchaseData;

    // rules for the rating id for showing/requiring fields
    public fieldConfigs: FieldConfigs;

    // rules for the rating id for min/max values (most values should be using package configuration values)
    public constraints: ConstraintRules;

    // the package being purchased in the purchase path
    public currentPackage: ApiPackage;

    // packages that are available for the current agent/agency.
    // Use for situations like package swap based on recommenedation
    public packageAgreements: PackageAgreement;

    // prevent navigation from moving forward for things like
    // invalid data, callout in progress, etc.
    public abstract canContinue(): Observable<boolean>;

    // write values to the purchase path data so they can be stored
    // in session storage
    public abstract writeValues(purchaseData: PurchaseData, override: WriteValueOverride): void;

    // called when all initializer data is in place to build a form
    public abstract buildForm(): void;

    constructor(private navigationService: PurchaseNavigationService) {
        this.navigationService.initializeCurrentComponent(this);
    }

    // perform any last actions before advancing to the next step
    public onContinue(): Observable<any> {
        return Observable.of(null);
    }

    // overrideable to say if a quote should be run after
    // leaving the step
    public quoteBeforeContinue(): boolean {
        return false;
    }

    protected quote(emitResult: boolean, quoteCoverages: boolean, flightCount: number): Observable<ApiQuoteResponse> {
        if (emitResult) {
            this.quotingStatusChanged.emit(true);
        }

        const getQuote: Observable<ApiQuoteResponse> = this.navigationService.quoteCurrentPurchaseData(emitResult, quoteCoverages, flightCount);

        getQuote.subscribe(quote => { }, null, () => { this.quotingStatusChanged.emit(false); });

        return getQuote;
    }

    protected get currentQuote(): ApiQuoteResponse {
        return this.navigationService.currentQuote;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/navigation-step.component.ts